<template>
    <kgr-loading v-if="loading" />
    <div v-else>
        <div>
            <div class="kgr-alert kgr-alert--info kgr-row">
                {{ tInfoText }}
            </div>
            <div class="kgr-row">
                <kgr-radio
                    v-model="letterDraft.isDraftSet"
                    :options="draftOptions"
                    :inline="true"
                />
            </div>
            <div class="kgr-row">
                <kgr-letter-draft-set-select
                    v-if="letterDraft.isDraftSet"
                    v-model="letterDraft.draftSet"
                    :club-id="clubId"
                />
                <kgr-letter-draft-select
                    v-else
                    v-model="letterDraft.draft"
                    :club-id="clubId"
                    entity="member"
                />
            </div>
            <div class="kgr-row">
                <kgr-checkbox
                    v-model="letterDraft.addToExchangeFolder"
                    :label="tLabelAddToExchangeFolder"
                />
            </div>
            <div class="kgr-row kgr-grid kgr-grid--columnGutters">
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="tLabelEmail"
                        :error="error"
                        field-name="senderEmail"
                    >
                        <kgr-dropdown
                            v-model="letterDraft.senderEmail"
                            display="email"
                            :options="emailOptions"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="tLabelReferenceDate"
                        :error="error"
                        field-name="referenceDate"
                    >
                        <kgr-date-picker
                            v-model="letterDraft.referenceDate"
                            label=""
                        />
                    </kgr-form-row>
                </div>
            </div>
            <kgr-form-row
                :label="tLabelSubject"
                :error="error"
                field-name="subject"
            >
                <kgr-text-input v-model="letterDraft.subject" />
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelMessage"
                :error="error"
                field-name="message"
            >
                <textarea
                    v-model.trim="letterDraft.message"
                    rows="5"
                    class="kgr-input"
                    style="min-height: 6em;height: 6em"
                ></textarea>
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelFiles"
                :error="error"
                field-name="senderFiles"
            >
                <kgr-club-file-multi-select
                    v-model="letterDraft.attachments"
                    :club-id="clubId"
                    entity="files"
                />
            </kgr-form-row>

            <hr class="kgr-separator" />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="$emit('onClose')"
                >
                    {{ tButtonCancel }}
                </button>
                <button
                    class="kgr-button"
                    :value="tButtonExecuteTestRun"
                    :disabled="!isValidData"
                    @click="sendLetterDraft(true)"
                >
                    {{ tButtonExecuteTestRun }}
                </button>
                <button
                    class="kgr-button kgr-button--accent"
                    :value="tButtonExecute"
                    :disabled="!isValidData"
                    @click="sendLetterDraft(false)"
                >
                    {{ tButtonExecute }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BatchSendLetterDraft from './BatchSendLetterDraft.js';
import Checkbox from '../../../../../common/form/checkbox/Checkbox.vue';
import ClubFileMultiSelect from '../../../../../common/form/select/ClubFileMultiSelect.vue';
import DatePicker from '../../../../../common/form/picker/DatePicker';
import DropDown from '../../../../../common/form/select/Dropdown.vue';
import Error from '../../../../../../js/model/Error';
import FormRow from '../../../../../common/form/FormRow';
import GenericRadio from '../../../../../../components/common/form/radio/GenericRadio';
import LetterDraftSelect from '../../../../../common/form/select/LetterDraftSelect.vue';
import LetterDraftSendersRepository from '../../../../../../js/repository/LetterDraftSendersRepository.js';
import LetterDraftSetSelect from '../../../../../common/form/select/LetterDraftSetSelect.vue';
import Loading from '../../../../../common/Loading.vue';
import TextInput from '../../../../../common/form/input/TextInput.vue';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-form-row': FormRow,
        'kgr-radio': GenericRadio,
        'kgr-dropdown': DropDown,
        'kgr-letter-draft-select': LetterDraftSelect,
        'kgr-letter-draft-set-select': LetterDraftSetSelect,
        'kgr-club-file-multi-select': ClubFileMultiSelect,
        'kgr-text-input': TextInput,
        'kgr-checkbox': Checkbox,
        'kgr-date-picker': DatePicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        entity: {
            type: String,
            required: true,
        },
        listId: {
            type: Number,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        savedActionData: {
            type: Object,
            required: false,
            default: () => null,
        },
    },
    data() {
        return {
            letterDraft: new BatchSendLetterDraft(this.entity),
            error: new Error(),
            draftOptions: {
                draft: false,
                draftSet: true,
            },
            emailOptions: [],
        };
    },
    computed: {
        tButtonCancel() {
            return this.$t('cancel');
        },
        tInfoText() {
            return this.$t('Lists.actions.SendLetterDraft.infoText', { count: this.entityIds.length });
        },
        tLabelSubject() {
            return this.$t('Lists.actions.SendLetterDraft.form.subject');
        },
        tLabelMessage() {
            return this.$t('Lists.actions.SendLetterDraft.form.message');
        },
        tLabelEmail() {
            return this.$t('Lists.actions.SendLetterDraft.form.email');
        },
        tLabelFiles() {
            return this.$t('Anhang');
        },
        tLabelReferenceDate() {
            return this.$t('Lists.actions.SendLetterDraft.form.referenceDate');
        },
        tLabelAddToExchangeFolder() {
            return this.$t('Vorlage zum Datenaustauschordner hinzufügen');
        },
        tButtonExecute() {
            return this.$t('Ausführen');
        },
        tButtonExecuteTestRun() {
            return this.$t('Lists.actions.executeTestRun');
        },
        isValidData() {
            return this.letterDraft.isValid();
        },
    },
    created() {
        LetterDraftSendersRepository.findAll(this.clubId).then((data) => {
            this.emailOptions = data;
        });
    },
    mounted() {
        this.assignDefaultData();
    },
    updated() {
        this.assignDefaultData();
    },
    methods: {
        sendLetterDraft(isTestRun) {
            if (!this.letterDraft.isValid()) {
                return;
            }
            this.$emit('executeAction', this.letterDraft, isTestRun);
        },
        assignDefaultData() {
            this.letterDraft.ids = this.entityIds;
            if (this.savedActionData !== null && this.savedActionData instanceof BatchSendLetterDraft) {
                this.letterDraft = this.savedActionData;
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
